import { createRouter, createWebHistory } from 'vue-router'
import UserReg from '../views/UserReg.vue'
import Home from '../views/Home.vue'
import Page from '../views/Page.vue'
import Article from '../views/Article.vue'
import PageImages from '../views/PageImages.vue'

const routes = [
  {
    path: '/reg',
    name: 'ref',
    component: UserReg
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    children: [
      {
        path: ':pageId',
        name: 'page',
        component: Page,
        props: true,
        children: [
          {
            path: ':articleId',
            name: 'article',
            component: Article,
            props: true
          },
          {
            path: 'images',
            name: 'page-images',
            component: PageImages,
            props: true
          }
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
